module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-3@2x-300c5e340a0f76325fd2985410bb3a68.png";